import React, { useState } from "react";

import styles from "./FormInput.module.css";

interface FormInputProps {
  id: string;
  name: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  className?: string;
  hasError?: boolean;
  disabled?: boolean;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");

export const FormInput: React.FC<FormInputProps> = ({
  id,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  className = "",
  hasError = false,
  disabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  return (
    <div className={styles.wrapper}>
      <input
        id={id}
        name={name}
        type={inputType}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        className={cn(
          styles.input,
          hasError ? styles.inputError : styles.inputNormal,
          isPasswordField && styles.inputWithToggle,
          className,
        )}
      />
      {isPasswordField && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className={styles.passwordToggle}
          tabIndex={-1}
        >
          {showPassword ? "Скрыть" : "Показать"}
        </button>
      )}
    </div>
  );
};
